import React from 'react';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import UserIcon from '../../assets/icons/icon-user.svg';
import UploadIcon from '../../assets/icons/icon-cloud-upload.svg';
import SupportIcon from '../../assets/icons/icon-helpcenter.svg';
import { ListItemMenu } from '../../services/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconCar from '../../assets/icons/icon-car';
import IconDashboard from '../../assets/icons/icon-dashboard';
import IconSettings from '../../assets/icons/icon-settings';
import IconDollar from '../../assets/icons/icon-dollar';
import IconUserId from '../../assets/icons/icon-user-id';
import IconBuilding from '../../assets/icons/icon-building';
import IconTruck from '../../assets/icons/icon-truck';
import IconUserRemove from '../../assets/icons/icon-user-remove';
import IconReprocessing from '../../assets/icons/icon-reprocessing';

export const DRAWER_MENU = 240;

export const DRAWER_ICON: { [key: string]: JSX.Element } = {
  dashboard: <IconDashboard />,
  freight: <IconCar />,
  reprocessing: <IconReprocessing />,
  configurations: <IconSettings />,
  distributor: <IconBuilding />,
  typeVehicle: <IconTruck />,
  driver: <IconUserId />,
  refusal: <IconUserRemove />,
  money: <IconDollar />,
  import: <img src={UploadIcon} alt="Upload icon" />,
  users: <img src={UserIcon} alt="User Icon" />,
  support: <img src={SupportIcon} alt="Support Icon" />,
  truck: <FontAwesomeIcon icon={solid('truck-front')} size="lg" color="#fff" />,
  file: <FontAwesomeIcon icon={solid('file-invoice')} size="lg" color="#fff" />,
};

export const LIST_MENU: ListItemMenu[] = [
  { name: 'Dashboard', icon: 'dashboard', routerName: 'dashboard-admin' },
  { name: 'Gestão de Fretes', icon: 'freight', routerName: 'shippings' },
  { name: 'Motoristas', icon: 'driver', routerName: 'drivers' },
  { name: 'Pagamentos', icon: 'money', routerName: 'payment-order-groups' },
  { name: 'Distribuidoras', icon: 'distributor', routerName: 'companies' },
];

export const LIST_MENU_COMPANY: ListItemMenu[] = [
  { name: 'Dashboard', icon: 'dashboard', routerName: 'dashboard' },
  { name: 'Gestão de Fretes', icon: 'freight', routerName: 'shippings' },
  {
    name: 'Motoristas da casa',
    icon: 'driver',
    routerName: 'private-drivers',
  },
  { name: 'Veiculos da casa', icon: 'truck', routerName: 'private-vehicles' },
  { name: 'Reprocessamento', icon: 'reprocessing', routerName: 'reprocessing' },
  {
    name: 'Ordens de Pagamento',
    icon: 'money',
    routerName: 'payment-order-groups',
  },
  {
    name: 'Configurações',
    icon: 'configurations',
    routerName: 'configurations',
  },
];

export const LIST_COLLAPSE_MENU = [
  { name: 'Usuários', icon: 'users', routerName: 'users-admin' },
  {
    name: 'Tipos de veículos',
    icon: 'typeVehicle',
    routerName: 'vehicle-types',
  },

  {
    name: 'Motivos de recusa',
    icon: 'refusal',
    routerName: 'reasons-refusal',
  },
];

export const routesMapping = {
  'payment-order-groups': 'Ordens de Pagamento',
  shippings: 'Gestão de Fretes',
  view: 'Detalhes do Frete',
  edit: 'Edição',
  create: 'Cadastro',
  dashboard: 'Dashboard',
  'dashboard-admin': 'Dashboard',
  drivers: 'Motoristas',
  companies: 'Distribuidoras',
  'vehicle-types': 'Tipos de veículos',
  users: 'Usuários',
  import: 'Nova Importação',
  reprocessing: 'Reprocessamento',
  configurations: 'Configurações',
  'reasons-refusal': 'Motivos de recusa',
  'users-admin': 'Usuários',
  'private-drivers': 'Motoristas da casa',
  'private-vehicles': 'Veículos da casa',
};
